"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var async_1 = __importDefault(require("react-select/async"));
var mobx_react_1 = require("mobx-react");
var trackProductNameInputCompleted = function (productName) {
    var _a;
    if (!productName || typeof window === 'undefined') {
        return;
    }
    var w = window;
    (_a = w.dataLayer) !== null && _a !== void 0 ? _a : (w.dataLayer = []);
    w.dataLayer.push({
        event: 'product_name_input_completed',
        product_name: productName
    });
};
var ReactSelectAsyncInput = (0, mobx_react_1.observer)(function (_a) {
    var store = _a.store;
    var _b = (0, react_1.useState)(''), inputValue = _b[0], setInputValue = _b[1];
    var handleInputChange = function (newInputValue, actionMeta) {
        if (actionMeta.action === 'input-change') {
            setInputValue(newInputValue);
            store.handleInputChange(newInputValue, actionMeta);
        }
    };
    var prepareForEdit = function () { if (store.value)
        setInputValue(store.value); };
    return (react_1.default.createElement("div", { ref: store.selectWrapperRef },
        react_1.default.createElement(async_1.default, { name: store.name, value: store.selectedOption, onChange: function (option) {
                setInputValue('');
                store.handleChange(option);
            }, onBlur: function () {
                store.handleBlur();
                trackProductNameInputCompleted(store.value);
            }, inputValue: inputValue, onInputChange: handleInputChange, onMenuOpen: function () {
                store.handleMenuOpen;
                prepareForEdit();
            }, onMenuClose: store.handleMenuClose, onFocus: store.handleFocus, loadOptions: store.loadOptions, cacheOptions: false, filterOption: null, isClearable: true, placeholder: "\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044", loadingMessage: function () { return "検索中です……"; }, noOptionsMessage: function () { return "候補なし"; } })));
});
exports.default = ReactSelectAsyncInput;
